/**
 * Classification status API (DOP-250).
 *
 * The sidebar needs "is this room still analyzing?" for EVERY deal room, not
 * just the selected one, so it asks once for all of them rather than fanning
 * out a request per room.
 */

import { z } from "zod/v3";
import { apiService } from "./api";

const projectClassificationStatusSchema = z.object({
	project_id: z.string(),
	pending: z.number(),
	processing: z.number(),
	completed: z.number(),
	failed: z.number(),
	is_processing: z.boolean(),
});

const projectsClassificationStatusSchema = z.object({
	projects: z.array(projectClassificationStatusSchema),
});

export type ProjectClassificationStatus = z.infer<
	typeof projectClassificationStatusSchema
>;

export const getProjectsClassificationStatus = async (): Promise<
	ProjectClassificationStatus[]
> => {
	const raw = await apiService.get<unknown>(
		`${apiService.getBaseUrlForVersion("v3")}/projects/classification-status`,
	);
	return projectsClassificationStatusSchema.parse(raw).projects;
};
